import get from 'lodash/get';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import T from 'prop-types';
import React, { useContext, useMemo, useState } from 'react';

export const FormContext = React.createContext({});

export const FormContextProvider = ({
  customComponents = {},
  pagesConfig = {},
  review: { readOnlyReviewSections = [] } = {},
  ...props
}) => {
  const [inReviewEdit, setInReviewEdit] = useState(false);

  const excludePages = useMemo(
    () => keys(pickBy(pagesConfig, value => value.exclude === true)),
    []
  );

  const contextValue = {
    customComponents,
    pagesConfig: {
      ...pagesConfig,
      excludePages,
    },
    review: {
      inReviewEdit,
      setInReviewEdit,
      readOnlyReviewSections,
    },
  };

  return <FormContext.Provider value={contextValue} {...props} />;
};

FormContextProvider.propTypes = {
  customComponents: T.object,
  pagesConfig: T.object,
  review: T.shape({
    readOnlyReviewSections: T.arrayOf(T.string),
  }),
};

export const useCustomComponentsContext = () =>
  get(useContext(FormContext), 'customComponents', {});

export const usePagesConfigContext = () =>
  get(useContext(FormContext), 'pagesConfig', {});

export const useReviewContext = () =>
  get(useContext(FormContext), 'review', {});
